import { render, staticRenderFns } from "./MenuSucursal.vue?vue&type=template&id=74994ebe"
import script from "./MenuSucursal.vue?vue&type=script&lang=js"
export * from "./MenuSucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports